module.exports = __webpack_public_path__ + "img/academic_years.d2bb2346.png";